<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { NxSearchInput, NxToggleGroup } from '@blpde/nx-ui';
import type { DictionaryLanguage } from '../dictionaryFile';
import { DICTIONARY_TEXT } from './labels';

/**
 * The bar above a dictionary list: a search over the list, the language
 * filter, and the tab's own actions in the default slot.
 */
const search = defineModel<string>('search', { default: '' });
const lang = defineModel<DictionaryLanguage | 'all'>('lang', { default: 'all' });
const { t } = useI18n();
const T = DICTIONARY_TEXT;

const languages = computed(() => [
  { value: 'all' as const, label: t(`${T}.langs.all`) },
  { value: 'de' as const, label: t(`${T}.langs.de`) },
  { value: 'en' as const, label: t(`${T}.langs.en`) },
]);
</script>

<template>
  <div class="dict-toolbar">
    <div class="dict-search" data-testid="dictionary-search">
      <NxSearchInput v-model="search" :placeholder="t(`${T}.search`)" clearable />
    </div>
    <NxToggleGroup v-model="lang" :label="t(`${T}.langs.label`)" :options="languages" />
    <span class="dict-grow" />
    <slot />
  </div>
</template>

<style scoped>
.dict-toolbar {
  display: flex;
  align-items: center;
  gap: var(--nxt-space-sm);
  flex-wrap: wrap;
}
.dict-search {
  width: calc(var(--nxt-size-unit) * 15);
  flex: none;
}
.dict-grow {
  flex: 1;
}
</style>
